var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 22.4389L10.3095 20.8704C4.30114 15.3214 0.334473 11.6497 0.334473 7.17006C0.334473 3.49841 3.15781 0.634766 6.75114 0.634766C8.78114 0.634766 10.7295 1.59724 12.0011 3.10629C13.2728 1.59724 15.2211 0.634766 17.2511 0.634766C20.8445 0.634766 23.6678 3.49841 23.6678 7.17006C23.6678 11.6497 19.7011 15.3214 13.6928 20.8704L12.0011 22.4389Z",
    fill: "#FF7400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishListIcon);
export default __webpack_public_path__ + "static/media/WishListIcon.34458eb65c1aabb6ee6ea1633898465b.svg";
export { ForwardRef as ReactComponent };